import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesCustomerActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Partner/PartnerBrowser")
	}

	render() {
		return (
			<Activity 
				menu="SLS09"
				name="SalesCustomer"
				RenderedComponent={this.RenderedComponent}
				context="SalesCustomer"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesCustomerActivity)
